//utility functions

export const getItemFromLocalStorage = (name) => {
    if (name) {
        return JSON.parse(localStorage.getItem(name))
    }
}

export const removeItemFromLocalStorage = (name) => {
    if (name) {
        return localStorage.removeItem(name)
    }
}